import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {filter, map} from 'rxjs/operators';


/**
 *Local cache for the application.
 * This stores the data as key value pair.
 */

interface BroadcastEvent {
    key: any;
    data?: any;
}

/**
 * Events with custom name.
 *Used when a custom event is required.
 * Note that angular doesn't unsubscribe these events automatically when destroying a component/module.
 * So, make sure to unsubscribe in ngOnDestroy life cycle hook.
 */

@Injectable()
export class AppEventService {

    private _eventBus: Subject<BroadcastEvent>;

    constructor() {
        this._eventBus = new Subject<BroadcastEvent>();
    }

    broadcast(key: any, data?: any) {
        this._eventBus.next({key, data});
    }

    on<T>(key: any): Observable<T> {
        return this._eventBus.asObservable()
            .pipe(
                filter(event => event.key === key),
                map(event => <T>event.data)
            );
    }

}
